import { BreadCrumbs } from '../../../subkit-ui';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PageHeading = function PageHeading(_ref) {
  var pageTitle = _ref.pageTitle,
      breadCrumbs = _ref.breadCrumbs,
      containerClassNames = _ref.containerClassNames;
  return /*#__PURE__*/_jsxs("div", {
    className: containerClassNames,
    children: [(breadCrumbs === null || breadCrumbs === void 0 ? void 0 : breadCrumbs.length) > 0 && /*#__PURE__*/_jsx(BreadCrumbs, {
      breadCrumbs: breadCrumbs
    }), /*#__PURE__*/_jsx("h1", {
      className: "font-serif text-3xl m-0 ws-pre-line mt-2 pt-0",
      children: pageTitle
    })]
  });
};
PageHeading.defaultProps = {
  containerClassNames: ''
};